import Axios from "axios";
import {
    SET_DOCUMENTS_ARCHIVE_LIST,
    UNSET_DOCUMENTS_ARCHIVE_LIST,
} from "@/store/mutation-types";

import { 
    getArchivedDocumentsList,
    saveArchiveDocument,
    restoreArchivedDocument
} from "@/store/api";

const state = {
    getArchivedDocumentsList: [],
};

const getters = {
    getArchivedDocumentsList(state) {
        return state.getArchivedDocumentsList;
    },
};

const mutations = {
    [SET_DOCUMENTS_ARCHIVE_LIST](state, data) {
        state.getArchivedDocumentsList = data;
    },
    [UNSET_DOCUMENTS_ARCHIVE_LIST](state) {
        state.getArchivedDocumentsList = [];
    },
};

const actions = {
    getArchivedDocumentsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", {color: "primary"});
            Axios.get(getArchivedDocumentsList, { params: data})
                .then(function (response) {
                    commit('SET_DOCUMENTS_ARCHIVE_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_DOCUMENTS_ARCHIVE_LIST')
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING")
                });
        });
    },

    saveArchiveDocument({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveArchiveDocument, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    restoreArchivedDocument({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(restoreArchivedDocument, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

};

export default {
    state,
    getters,
    actions,
    mutations,
};
